<template>
    <AdminLayout>
        <div class="table-responsive p-3">
            <table class="table table-xs table-hover">
                <thead>
                    <tr>
                        <th>Username</th>
                        <th>Fullname</th>
                        <th>Onhand</th>
                    </tr>
                    <tr>
                        <th>
                            <input class="form-control" />
                        </th>
                           <th>
                            <input class="form-control" />
                        </th>
                           <th>
                            <input class="form-control" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="user in users" :key="user.syspk_user">
                        <td>{{ user.username_user }}</td>
                        <td>{{ user.fullname_user }}</td>
                        <td class="text-end">{{ Formatters.formatCurrency(user.lesserAmount) }}</td>
                    </tr>
                </tbody>
            </table>

        </div>
    </AdminLayout>
</template>

<script setup>
import AdminLayout from '@/layouts/AdminLayout.vue';
import userService from '@/services/userService';
import Formatters from '@/utils/formatters';
import { onMounted, ref } from 'vue';
const users = ref([]);


const search = async () => {
    users.value = await userService.search({ username_user: "" });
}

onMounted(() => {
    search();
});
</script>